import { LocalStorageService } from './../services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
// import { CookieService } from 'angular2-cookie/core';
import { Injectable } from '@angular/core';

@Injectable()
export class LanguageService {

  constructor(
      // private cookieService: CookieService,
      private translateService: TranslateService,
      private localStorageService: LocalStorageService
      ) { }

  setLanguage (language) {
    // console.log('USTAWIAM JĘZYK');
    this.localStorageService.set('lang', language);
  }

  getLanguage () {
      //let language = this.localStorageService.get('lang');
    //   if (language === null) {
    //       let browserLang = this.translateService.getBrowserLang();
    //       return browserLang.match(/eng|pl/) ? browserLang : 'eng';
    //   }
      // return this.localStorageService.get('lang') == 'pl' || 'eng' ? 
      //   this.localStorageService.get('lang') : 'eng';

      return 'pl';
  }
}



// WEBPACK FOOTER //
// ./src/app/services/language.service.ts